import BasicTeamSectionPage from "./BasicTeamSectionPage";

export default BasicTeamSectionPage;
